import { z } from "zod";

export const TOOL_NAME_PATTERN = /^[a-zA-Z0-9_]{1,64}$/;
export const ToolNameSchema = z.string().regex(TOOL_NAME_PATTERN, "tool names are ^[a-zA-Z0-9_]{1,64}$");
export type ToolName = z.infer<typeof ToolNameSchema>;
